import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  listAddress: [],
  listUnit: [],
  listCustomer: [],
  lstOrganization: [],
  loading: false,
  addressSelect: {},
  OrganizationSelect: {},
  condition: {
    CurrentPage: 1,
    PageSize: 10,
    SearchText: "",
    GuestType: undefined,
  },
  total: 0,
  listProvince: [],
  listWaterPrice: [],
}

export const customerDirectorySlice = createSlice({
  name: "customerDirectory",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setAddressSelect: (state, action) => {
      state.addressSelect = action.payload
    },
    setListAddress: (state, action) => {
      state.listAddress = action.payload
    },
    setListUnit: (state, action) => {
      state.listUnit = action.payload
    },

    setOrganizationSelect: (state, action) => {
      state.OrganizationSelect = action.payload
    },
    setListOrganization: (state, action) => {
      state.lstOrganization = action.payload
    },

    setListCustomer: (state, action) => {
      state.listCustomer = action.payload
    },
    setTotal: (state, action) => {
      state.total = action.payload
    },
    setListProvince: (state, action) => {
      state.listProvince = action.payload
    },
    setListWaterPrice: (state, action) => {
      state.listWaterPrice = action.payload
    },
    changCondition: (state, action) => {
      state.condition = action.payload
    },
  },
})

export const {
  setListAddress,
  setListOrganization,
  setListCustomer,
  setLoading,
  setAddressSelect,
  setOrganizationSelect,
  changCondition,
  setListProvince,
  setTotal,
  setListWaterPrice,
  setUnitSelect,
  setListUnit,
} = customerDirectorySlice.actions

export default customerDirectorySlice.reducer
